import React, { useState, useContext } from 'react';
import { AlertContext } from '../AlertContext';
import '../css/Form.css'
const ContactForm = ({apiUrl}) => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    enquiry: '',
    address: ''
  });

  const { showAlert } = useContext(AlertContext);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${apiUrl}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.status === 201) {
        showAlert('Form submitted successfully', 'success');
      } else {
        showAlert('Error: Could not submit form. Please try again.', 'danger');
      }

      // Reset form fields after submission if needed
      setFormData({
        name: '',
        phoneNumber: '',
        enquiry: '',
        address: ''
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="container">
      <h3 className='text-center'>Please Fill this form for Enquiry</h3>
      <h3 className="container">You can also contact us at <br />Email: aquatreatuf@yahoo.co.in <br />Mob:+91 9448185916</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="name">Name:</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="form-field">
          <label htmlFor="phoneNumber">Phone Number:</label>
          <input type="phone" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
        </div>
        <div className="form-field">
          <label htmlFor="enquiry">Enquiry:</label>
          <input type="text" name="enquiry" value={formData.enquiry} onChange={handleChange} required />
        </div>
        <div className="form-field">
          <label htmlFor="address">Address:</label>
          <textarea name="address" value={formData.address} onChange={handleChange} required></textarea>
        </div>
        <div className="button">
          <button className="submit-button" type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
